export class MetaElementAccessoryCategoryDef {
  public static readonly ACCESSORY_CATEGORY_LABELING = 'labeling';
}
